// extracted by mini-css-extract-plugin
export default {"tabs":"CustomTab_tabs__4PEPI","tab":"CustomTab_tab__5PdHn","active":"CustomTab_active__HQIRj","tab-content":"CustomTab_tab-content__h3-kv"};